/** Shared values for NaturalsCameraSelect (auto facing + device id + native USB). */

export const AUTO_FRONT = 'auto:front';
export const AUTO_REAR = 'auto:rear';

export function deviceSelectValue(deviceId) {
  const id = typeof deviceId === 'string' ? deviceId.trim() : '';
  return id ? `device:${id}` : '';
}

export function nativeSelectValue(nativeId) {
  const id = nativeId == null ? '' : String(nativeId).trim();
  return id ? `native:${id}` : '';
}

export function parseCameraSelectValue(value) {
  const v = String(value || '').trim();
  if (!v) return { kind: 'none' };
  if (v === AUTO_FRONT) return { kind: 'auto', facing: 'front' };
  if (v === AUTO_REAR) return { kind: 'auto', facing: 'rear' };
  if (v.startsWith('device:')) return { kind: 'device', deviceId: v.slice(7) };
  if (v.startsWith('native:')) return { kind: 'native', nativeId: v.slice(7) };
  return { kind: 'device', deviceId: v };
}

export function resolveFaceCameraSelectValue({ deviceId, facing }) {
  const id = typeof deviceId === 'string' ? deviceId.trim() : '';
  if (id) return deviceSelectValue(id);
  return facing === 'rear' ? AUTO_REAR : AUTO_FRONT;
}

export function resolveMacroCameraSelectValue({ useNativeUsb, nativeId, deviceId, webFacing }) {
  if (useNativeUsb && nativeId != null && String(nativeId).trim()) {
    return nativeSelectValue(nativeId);
  }
  const id = typeof deviceId === 'string' ? deviceId.trim() : '';
  if (id) return deviceSelectValue(id);
  return webFacing === 'rear' ? AUTO_REAR : AUTO_FRONT;
}
